import { useMutation, useQueryClient } from '@tanstack/react-query'
import { BigNumber } from 'ethers'
import { useWallet } from '~/lib/useWallet'
import { getVotingEscrowContract } from '~/contracts/getVotingEscrowContract'
import { sisTokenKeys } from '~/lib/queryKeys'
import { useVESISParams } from '~/hooks/useVESISParams'

export function useIncreaseAmount(value?: BigNumber) {
	const { config, provider } = useVESISParams()

	const { signer, account } = useWallet()

	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: async () => {
			if (!value) {
				return
			}

			const contract = getVotingEscrowContract(config, provider).connect(
				signer
			)

			const tx = await contract.increase_amount(value.toString())

			await tx.wait()
		},
		onSuccess() {
			queryClient.resetQueries({
				queryKey: sisTokenKeys.balance(config.chain.id, account),
			})
			queryClient.resetQueries({ queryKey: ['sis-lock'] })
		},
		onError(error) {
			console.error('Error increasing lock amount:', error)
		},
	})
}
